import axios from 'axios';
import AlertsAPI from './alerts'
import SattelliteAPI from './satellite'
import NewsletterAPI from './newsletter';

axios.interceptors.request.use(function (config) {
   // console.log(config.url, config.params)
   return config;
 }, function (error) {
   // Do something with request error
   return Promise.reject(error);
 });

const API = axios.create({
   baseURL: process.env.API_BASE_URL
})

export {
   API,
   AlertsAPI,
   SattelliteAPI,
   NewsletterAPI
}


// WEBPACK FOOTER //
// ./src/api/index.js